'use-strict'

import { App } from "../utilities/App";

import { showNavbarCart } from "./nav";

import { isset } from "../utilities/utilities";

function addToCartActions() {

	$(document).on('click', '.add-to-cart__color', function(e) {
		if($(this).parents('.modal').length == 0) {
			onClickAddToCartColor( $(this) );
		} else {
			onClickAddToCartColor( $(this), false );
		}

	});
	
	$(document).on('change', '.add-to-cart .qnt-counter__input', function() {
		onChangeAddToCartInput( $(this) );
	});
	$('.add-to-cart .qnt-counter__input').each(function() {
		onChangeAddToCartInput( $(this) );
	});
	
	$(document).on('click', 'button.add-to-cart__button', function() {
		onClickAddToCartButton( $(this) );
	});

	$(document).on('click', '.button-block', function() {
		onClickAddToCartButtonDisabled( $(this) );
	});

	// $('.add-to-cart').each(function() {
	// 	$( this ).on('click', function() {
	// 		addToCartClick($(this));
	// 	})
	// });

	// $('.add-to-cart__button').each(function() {

	// 	if ( $(this).data('id') === '' || !isset($(this).data('id')) ) $(this).attr('disabled', true);
		
	// });

	if( $('.add-to-cart__colors').length === 0 ) {
		$('.add-to-cart').each(function() {
			const span = $(this).find('.button-block span');
			span.css('display', 'none');
		});
	}

	if($('.more-products__element').length > 0) {
		$('.more-products__element').each(function() {
			if($(this).find('.add-to-cart__colors').length === 0) {
				const span = $(this).find('.button-block span');
				span.css('display', 'none');
			}
		});
	}

	if(window.location.search) {
		let params = window.location.search;

		params = params.replace('?', '').replace('_', ' ').replace('-', ' ').toLowerCase().split(' ');
		params = params.map(elem => elem[0].toUpperCase() + elem.slice(1)).join(' ');
	
		
		if($(`div[title="${params}"]`) && ! $(`div[title="${params}"]`).hasClass('variant-color--active')) {
			$(`div[title="${params}"]`).click();
		}
	}
	
}

function onClickAddToCartButtonDisabled( target ) {
	const button = target.children('button');
	const parent = target.parents('.add-to-cart');
	const alert = parent.find('.color-alert')
	if(parent.find('.add-to-cart__colors').length === 0) return;
	if(parent.find('.variant-color--active').length === 0 ) {
		if(! (alert.is(':visible')) ) {
			alert.fadeIn();
			setTimeout(function() {
				alert.fadeOut();
			}, 2000);
		}
	}
}

function newString(elem, attribute, new_path) {
	let path = elem.getAttribute(attribute);
	let first = path.substring(0, path.search('products/'));
	let second = path.substring(path.search('@'), path.length);
	return first + new_path + second;
}

function changeSource(rootBlock, sources, path) {

	sources.forEach(element => {
		if(element.getAttribute('srcset')) {
			const newPath = newString(element, 'srcset', path);
			if(newPath === element.getAttribute('srcset') ) return;
			rootBlock.classList.add('animate');
			element.setAttribute('srcset', newPath);
		}
		if(element.getAttribute('src')) {
			const newPath = newString(element, 'src', path);
			if(newPath === element.getAttribute('src') ) return;
			rootBlock.classList.add('animate');
			element.setAttribute('src', newPath);
		}
	});
}

function imageChangeByColorSlider(colorBlock, rootBlock, index = 0) {
	let currentSlide = index;
	function get_currentPath () {
		return colorBlock.querySelector(`[data-index="${currentSlide}"]`).getAttribute('data-path').replace('${extension}', '');
	}
	rootBlock.querySelector('.prev').addEventListener('click', prev);
	rootBlock.querySelector('.next').addEventListener('click', next);
	const slidesLenght = colorBlock.querySelectorAll('[data-index]').length;
	const sources = rootBlock.querySelectorAll('picture source, picture img');
	rootBlock.querySelector('img').addEventListener('transitionend', endAnimation, false);
	let path = get_currentPath();
	changeSource(rootBlock, sources, path);
	function endAnimation() {
		if( ! rootBlock.classList.contains('slider') ) rootBlock.classList.add('slider');
		if(rootBlock.querySelector('img').complete) {
			imageLoaded(rootBlock);
		} else {
			rootBlock.querySelector('img').addEventListener('load', imageLoaded(rootBlock));
		}
	}

	function prev () {
		currentSlide--;
		if(currentSlide < 0) currentSlide = slidesLenght - 1;
		rootBlock.classList.add('animate');
	} 

	function next () {
		currentSlide++;
		if(currentSlide > slidesLenght - 1) currentSlide = 0;
		rootBlock.classList.add('animate');
	}
}

function imageLoaded(rootBlock) {
	rootBlock.classList.remove('animate');
}



function imageChangeByColor(target) {
	const colorName = target.attr('title').toLowerCase().split(' ').join('_');
	if( ! document.querySelector(`[data-color=${colorName}]`)) return;
	const rootBlock = document.querySelector('.image_variant__block');
	const pathBlock = document.querySelector(`[data-color=${colorName}]`);
	if( pathBlock.childNodes.length > 0 ) {
		imageChangeByColorSlider(pathBlock, rootBlock);
	} 
	else {
		const path = pathBlock.getAttribute('data-path').replace('${extension}', '');
		const sources = rootBlock.querySelectorAll('picture source, picture img');
		// rootBlock.classList.add('animate');
		rootBlock.querySelector('img').addEventListener('transitionend', endAnimation, false);
		changeSource(rootBlock, sources, path);
		function endAnimation() {
			if( rootBlock.classList.contains('slider') ) rootBlock.classList.remove('slider');
			if(rootBlock.querySelector('img').complete) {
				imageLoaded(rootBlock);
			} else {
				rootBlock.querySelector('img').addEventListener('load', imageLoaded(rootBlock));
			}
		}
	}
}

function onClickAddToCartColor( target, n = 0 ) {
	if ( target.hasClass('variant-color--unavailable') ) return;
	if ( target.hasClass('variant-color--active') ) return;
	const parent = target.parents('.add-to-cart');
	const colorName = target.attr('title');
	const selectedColorLabel = target.parents('.add-to-cart__colors').find('.add-to-cart__colors-label > span');
	const addToCartButton = target.parents('.add-to-cart').find('.add-to-cart__button');
	const buttonBlock = parent.find(`.button-block span`);
	target.siblings('.variant-color--active').removeClass('variant-color--active');
	target.addClass('variant-color--active');
	buttonBlock.css('display', 'none');
	selectedColorLabel.text(colorName);

	addToCartButton.data('id', target.data('id')).attr('title', '');
	const sectionsWithColor = document.querySelectorAll(`.add-to-cart__colors-list .add-to-cart__color[title="${colorName}"]`);
	if(n !== false) {
		n++;
		sectionsWithColor.forEach(elem => {
			if(!elem.classList.contains('variant-color--active')) onClickAddToCartColor($(elem), n);
		});
	
		if(sectionsWithColor.length == n) imageChangeByColor(target); 
	}
}
function onChangeAddToCartInput( target ) {

	const addToCartButton = target.parents('.add-to-cart').find('.add-to-cart__button');
	const priceContainer  = target.parents('.add-to-cart').find('.add-to-cart__price');
	
	addToCartButton.data('quantity', target.val());

	let id = addToCartButton.data('id') || $( target.parents('.add-to-cart').find('.add-to-cart__color')[0] ).data('id');
	let quantity = addToCartButton.data('quantity');

	let price = App.getProductPrice(id, quantity);

	priceContainer.find('.old-price').text(App.getCurrencyFormat(price.oldPrice));
	priceContainer.find('.new-price').text(App.getCurrencyFormat(price.newPrice));

	if ( price.oldPrice > price.newPrice ) priceContainer.find('.old-price').fadeIn(0);
	else priceContainer.find('.old-price').fadeOut(0);

}
function onClickAddToCartButton( target ) {
	const id = target.data('id');
	const quantity = target.data('quantity');
	
	App.productPlus(id, quantity, showNavbarCart);
	const alert = target.parents('.button-block').find('div');
	if(alert.length == 0) return;
	if(! (alert.is(':visible')) ) {
		alert.fadeIn();
		setTimeout(function() {
			alert.fadeOut();
		}, 1000);
	}
	
}

function blogAddToCart(target) {
	
		
			const product = target.parents('.item');
			const variants = product.find('.products-grid__color');
			const alert = product.find('.color-alert');
			if(variants.length > 0) {
				if(product.find('.color--active').length > 0) {
					const id = target.data('id');
					App.productPlus(id, '1', showNavbarCart);
				} else {
					if(! (alert.is(':visible')) ) alert.fadeIn();
						setTimeout(function() {
							alert.fadeOut();
						}, 2000);
				}
			} else {
				const id = target.data('id');
				App.productPlus(id, '1', showNavbarCart);
			}
	
}

export {
	addToCartActions,
	blogAddToCart
};

